module.exports = __webpack_public_path__ + "static/media/quickCrossword.bfd238a8.svg";